import React, { useEffect, useState } from "react";
import { Tooltip, Radio, Image, Skeleton, Timeline } from "antd";
import { useDispatch, useSelector } from "react-redux";

import ErrorBoundary from "../../../ErrorBoundary";

import BackArrow from "../../../assets/BackArrow.svg";
import BackArrowWhite from "../../../assets/WhiteIcons/BackArrow_White.svg";
import Profile from "../../../assets/Profile_Pic.svg";
import Login from "../../../assets/deepDive/login.svg";
import Logout from "../../../assets/deepDive/Logout.svg";
import { setTrendsData } from "../../../redux/actions/WidgetMaker/WidgetAPI";
import { getPaneIndex, kFormatter } from "../../../redux/constants";
import SingleDate from "../../layout/DateTime/SingleDate";
import GraphList from "../../WidgetMaker/GraphList";
import { setOptionHighChart } from "../../../redux/actions/HighChart";
import NoGraphData from "../../workspace/DisplayChart/NoGraphData";
import { setIsTicketTrandsView } from "../../../redux/actions/dashboard/Tab1";
import { setShareTemplateData } from "../../../redux/actions/ApiCall/apiCall";

const AgentActivityTrends = ({ cardData, setTrandView }) => {
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state.Authentication.authParams);
  const trendsData = useSelector((state) => state.WidgetAPI.trendsData);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const opData = useSelector((state) => state.Highchart.Options);
  const [dataToggleValue, setDataToggleValue] = useState("time_wise_graph");
  const [graphData, setGraphData] = useState(null);
  const chart__styles = {
    width: "100%",
    height: "350px",
  };
  useEffect(() => {
    if (trendsData && trendsData?.graphs?.time_wise_graph) {
      if (dataToggleValue) {
        setGraphData(trendsData?.graphs?.[dataToggleValue]);
      } else {
        setGraphData(trendsData?.graphs?.time_wise_graph);
      }
    } else {
      !trendsData && setGraphData(null);
    }
  }, [trendsData]);

  const handleBack = () => {
    //setTrandView(false);
    dispatch(setTrendsData(null));
    if (shareTemplateData) {
      dispatch(
        setShareTemplateData({
          ...shareTemplateData,
          isTicketTrandsView: false,
        })
      );
    } else {
      let index = getPaneIndex(panes, activeKey);
      dispatch(setIsTicketTrandsView(false, panes, index));
    }
  };
  const onDataToggleValueChange = ({ target: { value } }) => {
    if (dataToggleValue && opData?.["Trends_" + dataToggleValue]) {
      let updatedOption = { ...opData };
      delete updatedOption?.["Trends_" + dataToggleValue];
      dispatch(setOptionHighChart(updatedOption));
    }
    setDataToggleValue(value);
    if (value) {
      setGraphData(trendsData?.graphs?.[value]);
    }
  };
  return (
    <div className="row m-0">
      <div className="col-12 col-md-3 pl-0 pr-0">
        <div
          className={`d-flex align-items-center text_heading font-weight500 fontSize-16 pl-15 pt-2 pb-2 border-bottom border-right border-color`}
          style={{ height: "6rem" }}
        >
          <img
            onClick={handleBack}
            src={authParams?.theme_type === "1" ? BackArrowWhite : BackArrow}
            style={{ maxWidth: "2rem" }}
            className={`cursor-pointer`}
            alt="Trends Back Arrow Img"
          />
          <span className="ml-2"> Agent Working Details</span>
        </div>
        <div
          className="custom_scroll1 border-right border-color"
          style={{ height: "calc(100vh - 6rem)", overflow: "auto" }}
        >
          {trendsData?.info_bar ? (
            <>
              {trendsData?.info_bar?.user_info ? (
                <div className="Collapse-div p-15 text_regular border-bottom border-color">
                  <div className="card-head text_heading d-flex align-items-center mb-15">
                    <Image
                      src={
                        trendsData?.info_bar?.user_info?.profile_picture ===
                          0 ||
                        trendsData?.info_bar?.user_info?.profile_picture ===
                          "" ||
                        !trendsData?.info_bar?.user_info?.profile_picture
                          ? Profile
                          : trendsData?.info_bar?.user_info?.profile_picture
                      }
                      fallback={Profile}
                      preview={false}
                      alt="Profile Images"
                      className="profileImg mr-1"
                      style={{ width: "4rem", height: "4rem" }}
                    />
                    <div className="d-flex flex-wrap w-100">
                      {
                        <div className="profileName line-height-normal">
                          {trendsData?.info_bar?.user_info?.name}
                        </div>
                      }
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mb-15">
                    <div className="d-flex flex-column">
                      <b className="mb-1">Login time</b>
                      <span className="blue_text font-size12 d-flex align-items-center">
                        <img
                          src={Login}
                          className="mr-2"
                          style={{ maxWidth: "1.5rem" }}
                          alt="Login at"
                        />
                        <span className={`text-left`}>
                          {trendsData?.info_bar?.user_info?.login_time}
                        </span>
                      </span>
                    </div>
                    <div className="d-flex flex-column">
                      <b className="mb-1">Logout time</b>
                      <span className="text_regular-gray font-size12 d-flex align-items-center">
                        <img
                          src={Logout}
                          className="mr-2"
                          style={{ maxWidth: "1.5rem" }}
                          alt="Logged out from"
                        />
                        <span className={`text-left`}>
                          {trendsData?.info_bar?.user_info?.logout_time}
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-15">
                    <b>Working Hours:</b>
                    <span className={`text-blue font-weight500 ml-1 text-left`}>
                      {trendsData?.info_bar?.user_info?.working_hours}
                    </span>
                  </div>
                  <div className="d-flex mb-15">
                    <div className="d-flex flex-column">
                      <b>Breaks: </b>
                    </div>
                    <div className="d-flex justify-content-between ml-25">
                      <div className="d-flex flex-column">
                        <span>No. Breaks </span>
                        <span className="blue_text d-flex align-items-center">
                          <span className={`font-weight500 text-left`}>
                            {trendsData?.info_bar?.user_info?.breaks}
                          </span>
                        </span>
                      </div>
                      <div className="d-flex flex-column ml-25">
                        <span>Total Break time</span>
                        <span className="text_regular-gray d-flex align-items-center">
                          <span className={`font-weight500 text-left`}>
                            {trendsData?.info_bar?.user_info?.total_break_time}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              {trendsData?.info_bar?.schedule_info ? (
                <>
                  <div className="p-15 text_regular border-bottom border-color">
                    <div className="text_heading font-weight500 text-transform__capitalize">
                      Schedule Timeline
                    </div>
                  </div>
                  {trendsData?.info_bar?.schedule_info && (
                    <div
                      className="custom_scroll1 border-bottom border-color p-15"
                      style={{
                        height: "30rem",
                        overflow: "auto",
                      }}
                    >
                      {trendsData?.info_bar?.schedule_info?.length ? (
                        <Timeline onChange={() => {}}>
                          {trendsData?.info_bar?.schedule_info?.map(
                            (schdule) => {
                              return (
                                <Timeline.Item
                                  color={
                                    schdule?.color ? schdule?.color : "gray"
                                  }
                                >
                                  <>
                                    <div className="text_regular font-weight500">
                                      {schdule?.name}
                                    </div>
                                    <div className="text_regular font-size12">
                                      {schdule?.value}
                                    </div>
                                  </>
                                </Timeline.Item>
                              );
                            }
                          )}
                        </Timeline>
                      ) : (
                        <div className="portlet__body">
                          <ErrorBoundary>
                            <NoGraphData
                              isDeepDiveList={true}
                              isDeepDiveTimeLineList={true}
                            />
                          </ErrorBoundary>
                        </div>
                      )}
                    </div>
                  )}
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            <>
              <div className="p-15 text_regular border-bottom border-color">
                <Skeleton
                  active
                  avatar={{ size: "default" }}
                  size="small"
                  paragraph={{ rows: 3 }}
                />
              </div>
              <div className="p-15 text_regular border-bottom border-color">
                <div className="text_heading font-weight500 text-transform__capitalize">
                  Schedule Timeline
                </div>
              </div>
              <div className="p-15 text_regular border-bottom border-color">
                <Skeleton
                  active
                  size="small"
                  title={false}
                  paragraph={{ rows: 3 }}
                />
              </div>
            </>
          )}
        </div>
      </div>
      <div className="col-12 col-md-9 pl-0 pr-0">
        <div
          className="trends_tabs text_heading d-flex align-items-center font-weight500 fontSize-16 pl-15 pt-2 pb-2 border-bottom border-color"
          style={{ height: "6rem" }}
        >
          <SingleDate
            type="trends"
            disabled={!trendsData ? true : false}
          ></SingleDate>
        </div>
        <div
          className="bg__gray custom_scroll1"
          style={{ height: "calc(100vh - 6rem)", overflow: "auto" }}
          id="AgentTreandsChartsContainer"
        >
          {trendsData?.info_bar ? (
            <>
              <div
                className="text_regular bg__white border-color p-15"
                style={{ minHeight: "20rem" }}
              >
                <div className="d-flex mb-15">
                  <div
                    className="mr-15"
                    style={{ width: "calc(80% - 1.5rem)" }}
                  >
                    <div
                      className={`wm-chart-cards-item box-shadow mr-15 p-15 w-100 h-100 bg__gray border d-inline-flex align-items-center justify-content-between`}
                      style={{
                        boxShadow: "0 0 0.6rem #c3cbd780",
                        borderRadius: "0.4rem",
                      }}
                    >
                      <div>
                        <div className="text_regular font-weight500 mb-1 line-height-normal">
                          <div>Assigned Tickets</div>
                          <div>(Includes Earlier On Hold Tickets)</div>
                        </div>
                        <div className="d-flex align-items-baseline">
                          <Tooltip
                            title={trendsData?.info_bar?.kpi_1?.assigned_tickets?.toLocaleString()}
                          >
                            <span className="wm-chart-card-value mr-1">
                              {kFormatter(
                                trendsData?.info_bar?.kpi_1?.assigned_tickets
                              )}
                            </span>
                          </Tooltip>
                        </div>
                      </div>
                      <div
                        className=" d-flex align-items-center ml-15 p-0 box-shadow border-radius-4 bg__white"
                        style={{ height: "9rem" }}
                      >
                        <div className="border-right border-color p-15 w-100 h-100">
                          <div className="text_regular font-weight500 mb-1 line-height-normal">
                            Unactioned Tickets
                          </div>
                          <div className="d-flex align-items-baseline">
                            <Tooltip
                              title={trendsData?.info_bar?.kpi_1?.unactioned_tickets?.toLocaleString()}
                            >
                              <span className="wm-chart-card-value mr-1">
                                {kFormatter(
                                  trendsData?.info_bar?.kpi_1
                                    ?.unactioned_tickets
                                )}
                              </span>
                            </Tooltip>
                          </div>
                        </div>

                        <div
                          className="border-right border-color p-15 w-100 h-100"
                          style={{ minWidth: "17.5rem" }}
                        >
                          <div className="text_regular font-weight500 mb-1 line-height-normal">
                            Tickets Worked On But Open
                          </div>
                          <div className="d-flex align-items-baseline">
                            <Tooltip
                              title={trendsData?.info_bar?.kpi_1?.worked_but_open?.toLocaleString()}
                            >
                              <span className="wm-chart-card-value mr-1">
                                {kFormatter(
                                  trendsData?.info_bar?.kpi_1?.worked_but_open
                                )}
                              </span>
                            </Tooltip>
                          </div>
                        </div>
                        <div className="p-15 w-100 h-100">
                          <div className="text_regular font-weight500 mb-1 line-height-normal">
                            Closed Tickets
                          </div>
                          <div className="d-flex align-items-baseline">
                            <Tooltip
                              title={trendsData?.info_bar?.kpi_1?.closed_tickets?.toLocaleString()}
                            >
                              <span className="wm-chart-card-value mr-1">
                                {kFormatter(
                                  trendsData?.info_bar?.kpi_1?.closed_tickets
                                )}
                              </span>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="" style={{ width: "20%" }}>
                    <div
                      className={`box-shadow p-15 w-100 h-100 d-flex align-items-center`}
                      style={{
                        boxShadow: "0 0 0.6rem #c3cbd780",
                        borderRadius: "0.4rem",
                      }}
                    >
                      <div>
                        <div className="text_regular font-weight500 mb-1 line-height-normal">
                          Average TAT To Closure
                        </div>
                        <div className="d-flex align-items-baseline">
                          <span className="wm-chart-card-value mr-1">
                            {trendsData?.info_bar?.kpi_2?.average_tat_closure
                              ? trendsData?.info_bar?.kpi_2?.average_tat_closure
                              : "0s"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex mb-15">
                  <div
                    className={` box-shadow mr-15 p-15 d-flex align-items-center`}
                    style={{
                      boxShadow: "0 0 0.6rem #c3cbd780",
                      borderRadius: "0.4rem",
                    }}
                  >
                    <div>
                      <div className="text_regular font-weight500 mb-1 line-height-normal">
                        Avg. Ticket Closed Per Hour
                      </div>
                      <div className="d-flex align-items-baseline">
                        <span className="wm-chart-card-value mr-1">
                          {trendsData?.info_bar?.kpi_2?.tickets_closed_hour}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={` box-shadow mr-15 p-15 d-flex align-items-center`}
                    style={{
                      boxShadow: "0 0 0.6rem #c3cbd780",
                      borderRadius: "0.4rem",
                    }}
                  >
                    <div>
                      <div className="text_regular font-weight500 mb-1 line-height-normal">
                        Avg. Ticket Assigned Per Hour
                      </div>
                      <div className="d-flex align-items-baseline">
                        <span className="wm-chart-card-value mr-1">
                          {trendsData?.info_bar?.kpi_2?.tickets_assigned_hour}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`box-shadow mr-15 p-15 d-flex align-items-center`}
                    style={{
                      boxShadow: "0 0 0.6rem #c3cbd780",
                      borderRadius: "0.4rem",
                    }}
                  >
                    <div>
                      <div className="text_regular font-weight500 mb-1 line-height-normal d-flex">
                        Avg. Agent Action Time{" "}
                        <Tooltip
                          placement="bottom"
                          title="The time agent takes either to close a ticket, respond to user or escalate to CSD"
                        >
                          <i className="fa fa-question-circle ml-1" />
                        </Tooltip>
                      </div>
                      <div className="d-flex align-items-baseline">
                        <span className="wm-chart-card-value mr-1">
                          {trendsData?.info_bar?.kpi_2?.avg_agent_action_time
                            ? trendsData?.info_bar?.kpi_2?.avg_agent_action_time
                            : "0s"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`box-shadow mr-15 p-15 d-flex align-items-center`}
                    style={{
                      boxShadow: "0 0 0.6rem #c3cbd780",
                      borderRadius: "0.4rem",
                    }}
                  >
                    <div>
                      <div className="text_regular font-weight500 mb-1 line-height-normal">
                        Closed Tickets Within Action Time
                      </div>
                      <div className="d-flex align-items-baseline">
                        <span className="wm-chart-card-value mr-1">
                          {
                            trendsData?.info_bar?.kpi_2
                              ?.closed_tickets_action_time
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`box-shadow p-15 d-flex align-items-center`}
                    style={{
                      boxShadow: "0 0 0.6rem #c3cbd780",
                      borderRadius: "0.4rem",
                    }}
                  >
                    <div>
                      <div className="text_regular font-weight500 mb-1 line-height-normal">
                        Closed Tickets with Action Breached
                      </div>
                      <div className="d-flex align-items-baseline">
                        <span className="wm-chart-card-value mr-1">
                          {
                            trendsData?.info_bar?.kpi_2
                              ?.closed_tickets_action_breached
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text_regular p-15">
                <div className="portlet1 p-0">
                  <div className="text_heading p-15 font-weight500 fontSize-16 border-bottom d-flex justify-content-between align-items-center">
                    <div>Ticket Closure Trend </div>
                    <div className="d-inline-flex align-items-center">
                      <Radio.Group
                        options={[
                          { label: "Time", value: "time_wise_graph" },
                          { label: "Channels", value: "channel_wise_graph" },
                        ]}
                        onChange={onDataToggleValueChange}
                        value={dataToggleValue}
                        optionType="button"
                        buttonStyle="solid"
                      />
                    </div>
                  </div>
                  <div className="p-15 widget_trends">
                    {typeof graphData === "object" &&
                    graphData?.x_axis &&
                    typeof graphData !== "string" ? (
                      <ErrorBoundary>
                        <GraphList
                          widgetMakerGraphData={graphData}
                          single={graphData}
                          style={chart__styles}
                          type={"combination"}
                          trends={true}
                          xaxis={
                            dataToggleValue === "time_wise_graph"
                              ? "Time"
                              : "Channel"
                          }
                          yaxis={"Count"}
                          id={"Trends_" + dataToggleValue}
                          template_id={"agent_activity_001"}
                          trends_type={
                            dataToggleValue === "time_wise_graph"
                              ? "time"
                              : null
                          }
                        />
                      </ErrorBoundary>
                    ) : (
                      <ErrorBoundary>
                        <NoGraphData
                          errorCode={graphData}
                          isDeepDiveList={true}
                        />
                      </ErrorBoundary>
                    )}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="text_regular bg__white border-color">
                <div
                  className="text_regular bg__white border-color p-15"
                  style={{ minHeight: "20rem" }}
                >
                  <div className="d-flex mb-15">
                    <div className="mr-15" style={{ width: "75%" }}>
                      <div
                        className={`wm-chart-cards-item box-shadow mr-15 p-15 w-100 h-100 bg__gray border d-inline-flex align-items-center justify-content-between`}
                        style={{
                          boxShadow: "0 0 0.6rem #c3cbd780",
                          borderRadius: "0.4rem",
                        }}
                      >
                        <Skeleton
                          active
                          size="small"
                          title={false}
                          paragraph={{ rows: 2 }}
                        />
                        <div
                          className=" d-flex align-items-center ml-15 p-0 box-shadow border-radius-4 bg__white"
                          style={{ height: "9rem" }}
                        >
                          <div
                            className="border-right border-color p-15 w-100 h-100"
                            style={{ minWidth: "15rem" }}
                          >
                            <Skeleton
                              active
                              size="small"
                              title={false}
                              paragraph={{ rows: 2 }}
                            />
                          </div>
                          <div
                            className="border-right border-color p-15 w-100 h-100"
                            style={{ minWidth: "15rem" }}
                          >
                            <Skeleton
                              active
                              size="small"
                              title={false}
                              paragraph={{ rows: 2 }}
                            />
                          </div>
                          <div
                            className="p-15 w-100 h-100"
                            style={{ minWidth: "15rem" }}
                          >
                            <Skeleton
                              active
                              size="small"
                              title={false}
                              paragraph={{ rows: 2 }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="" style={{ width: "25%" }}>
                      <div
                        className={`wm-chart-cards-item box-shadow mr-15 p-15 w-100 h-100 d-flex align-items-center`}
                        style={{
                          boxShadow: "0 0 0.6rem #c3cbd780",
                          borderRadius: "0.4rem",
                        }}
                      >
                        <Skeleton
                          active
                          size="small"
                          title={false}
                          paragraph={{ rows: 2 }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex mb-15">
                    <div
                      className={` box-shadow mr-15 p-15 h-100 d-flex align-items-center`}
                      style={{
                        boxShadow: "0 0 0.6rem #c3cbd780",
                        borderRadius: "0.4rem",
                        minWidth: "calc(20% - 1.5rem)",
                      }}
                    >
                      <Skeleton
                        active
                        size="small"
                        title={false}
                        paragraph={{ rows: 2 }}
                      />
                    </div>
                    <div
                      className={` box-shadow mr-15 p-15 h-100 d-flex align-items-center`}
                      style={{
                        boxShadow: "0 0 0.6rem #c3cbd780",
                        borderRadius: "0.4rem",
                        minWidth: "calc(20% - 1.5rem)",
                      }}
                    >
                      <Skeleton
                        active
                        size="small"
                        title={false}
                        paragraph={{ rows: 2 }}
                      />
                    </div>
                    <div
                      className={` box-shadow mr-15 p-15 h-100 d-flex align-items-center`}
                      style={{
                        boxShadow: "0 0 0.6rem #c3cbd780",
                        borderRadius: "0.4rem",
                        minWidth: "calc(20% - 1.5rem)",
                      }}
                    >
                      <Skeleton
                        active
                        size="small"
                        title={false}
                        paragraph={{ rows: 2 }}
                      />
                    </div>
                    <div
                      className={` box-shadow mr-15 p-15 h-100 d-flex align-items-center`}
                      style={{
                        boxShadow: "0 0 0.6rem #c3cbd780",
                        borderRadius: "0.4rem",
                        minWidth: "calc(20% - 1.5rem)",
                      }}
                    >
                      <Skeleton
                        active
                        size="small"
                        title={false}
                        paragraph={{ rows: 2 }}
                      />
                    </div>
                    <div
                      className={` box-shadow p-15 h-100 d-flex align-items-center`}
                      style={{
                        boxShadow: "0 0 0.6rem #c3cbd780",
                        borderRadius: "0.4rem",
                        minWidth: "20%",
                      }}
                    >
                      <Skeleton
                        active
                        size="small"
                        title={false}
                        paragraph={{ rows: 2 }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-15">
                <div className="text_regular bg__white border-color">
                  <div className="loader" style={{ height: "30rem" }}>
                    <div className="lds-ring">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default AgentActivityTrends;
